const REDACTED = '[redacted]';

const SENSITIVE_KEY_PATTERNS = [
  'password',
  'secret',
  'token',
  'authorization',
  'cookie',
  'apikey',
  'api_key',
  'api-key',
  'cardnumber',
  'card_number',
  'cvv',
  'cvc',
  'iban',
  'email',
  'phone',
  'mobile',
  'dob',
  'dateofbirth',
  'date_of_birth',
  'postcode',
  'post_code',
  'membership',
];

const EMAIL_PATTERN = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
// eslint-disable-next-line security/detect-unsafe-regex
const CARD_PATTERN = /\b(?:\d[ -]?){12,18}\d\b/g;
const PHONE_PATTERN = /(?:\+|00)[\d\s()-]{7,}[\d()]|0[\d\s()-]{9,}[\d()]/g;

const MAX_DEPTH = 8;

function isSensitiveKey(key: string): boolean {
  const normalized = key.toLowerCase();
  return SENSITIVE_KEY_PATTERNS.some((pattern) => normalized.includes(pattern));
}

function scrubString(value: string): string {
  return value
    .replace(EMAIL_PATTERN, '[redacted-email]')
    .replace(CARD_PATTERN, '[redacted-card]')
    .replace(PHONE_PATTERN, '[redacted-phone]');
}

function scrubValue(
  value: unknown,
  key: string | undefined,
  depth: number,
): unknown {
  if (key !== undefined && isSensitiveKey(key)) {
    return REDACTED;
  }
  if (typeof value === 'string') {
    return scrubString(value);
  }
  if (depth >= MAX_DEPTH) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map((item) => scrubValue(item, undefined, depth + 1));
  }
  if (value !== null && typeof value === 'object') {
    const result: Record<string, unknown> = {};
    for (const [childKey, childValue] of Object.entries(value)) {
      result[childKey] = scrubValue(childValue, childKey, depth + 1);
    }
    return result;
  }
  return value;
}

export function scrubSentryEvent<T>(event: T): T {
  if (event === null || typeof event !== 'object') {
    return event;
  }
  return scrubValue(event, undefined, 0) as T;
}
